import { gql } from '@apollo/client';

export const GET_JOURNAL_ENTRY = gql`
  query getJournalEntry($id: ID!) {
    journalEntry(id: $id) {
      id
      dateOfTransaction
      vendorName
      dataEntries {
        id
        amountInCents
        ledgerAccount {
          id
          name
        }
      }
      clientCatResponse
      clientComments {
        id
        author {
          id
          fullName
        }
        body
        createdOn
      }
      internalNotes {
        id
        author {
          id
          fullName
        }
        body
        flagged
        createdOn
      }
      historyEntries {
        date
        message
        from
        to
        user {
          id
          fullName
        }
        categorizerMethod
        categorizerLedgerName
        categorizerPattern
        reconciliationOrigin
      }
      addOn {
        id
        name
      }
      file {
        id
        pagesCount
        previewImages
      }
      categorizerRuleId
      categorizerMethod
    }
  }
`;

export const GET_JOURNAL_ENTRY_FORM_VALUES = gql`
  query getJournalEntryFormValues($clientId: ID!, $journalEntryId: ID!) {
    journalEntry(id: $journalEntryId) {
      id
      dateOfTransaction
      vendorName
      dataEntries {
        id
        amountInCents
        ledgerAccount {
          id
          name
        }
      }
      addOn {
        id
        name
      }
    }
    ledgerAccounts(clientId: $clientId) {
      id
      active
      name
    }
    addOns(clientId: $clientId) {
      id
      name
      accountType
    }
  }
`;

export const GET_CLIENT_RULE = gql`
  query getClientRule($id: ID!) {
    clientRule(id: $id) {
      id
      vendorContains
      createdBy
    }
  }
`;

export const UPDATE_JOURNAL_ENTRY = gql`
  mutation updateJournalEntry($journalEntryId: ID!, $journalEntryInput: JournalEntryInput!) {
    updateJournalEntry(journalEntryId: $journalEntryId, journalEntryInput: $journalEntryInput) {
      id
      vendorName
      dateOfTransaction
      addOn {
        id
      }
      dataEntries {
        id
        amountInCents
        ledgerAccount {
          id
        }
      }
    }
  }
`;

export const CREATE_JOURNAL_ENTRY_CLIENT_COMMENT = gql`
  mutation createJournalEntryClientComment($body: String!, $clientId: String!, $parentId: ID!) {
    createJournalEntryClientComment(
      clientCommentBody: $body
      journalEntryId: $parentId
      clientId: $clientId
    ) {
      id
      clientComments {
        id
        author {
          id
          fullName
        }
        body
        createdOn
      }
    }
  }
`;
